import { render } from "./TelInputSelect.vue?vue&type=template&id=e65bdefe&scoped=true"
import script from "./TelInputSelect.vue?vue&type=script&lang=js"
export * from "./TelInputSelect.vue?vue&type=script&lang=js"

import "./TelInputSelect.vue?vue&type=style&index=0&id=e65bdefe&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e65bdefe"]])

export default __exports__